/*
 *
 * DownloadReport reducer
 *
 */
import produce from 'immer';
import moment from 'moment';

import {
  DEFAULT_ACTION,
  SAVE_REPORTS,
  UPDATE_TABLE_DATA,
  ENABLE_LOADER,
  DISABLE_LOADER,
  UPDATE_FILTERS,
  RESET_FILTERS,
  HANDLE_GET_REPORT_BY_ID_RESPONSE,
  HANDLE_DOWNLOAD_REPORT_RESPONSE,
  HANDLE_DELETE_REPORT_RESPONSE,
  HANDLE_GENERATE_REPORT_RESPONSE,
  RESET_PAGE,
  RESET_MODAL,
  RESET_DATA,
  HANDLE_NEW_REPORT_STATUS,
} from './constants';

import {
  DEFAULT_PG_MENU_TAB_STATE,
  DEFAULT_CURRENT_PAGE,
  DOWNLOAD_REPORT,
} from '../../utils/constants';
import { getParam, downloadFromUrl } from '../../utils/common';

const getInitialState = () => ({
  activeNavigation: DOWNLOAD_REPORT,
  isLoading: false,
  showDownloadModal: false,
  downloadModalData: {},
  ...DEFAULT_PG_MENU_TAB_STATE,
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const downloadReportReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SAVE_REPORTS: {
        const { data } = action.data;
        draft.data = data;
        draft.isLoading = false;
        break;
      }
      case UPDATE_TABLE_DATA: {
        const {
          totalCount,
          hasPrevEnabled,
          hasNextEnabled,
          currentPageRowData,
        } = action.data;
        draft.totalCount = totalCount;
        draft.hasPrev = hasPrevEnabled;
        draft.hasNext = hasNextEnabled;
        draft.currentPageRowData = currentPageRowData;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }

      case UPDATE_FILTERS: {
        const { data } = action;
        const {
          appliedFilters,
          dateFilters,
          filtersForDisplay,
          ...filters
        } = data;

        if (appliedFilters) {
          draft.filters.appliedFilters = appliedFilters;
        }
        if (dateFilters) draft.filters.dateFilters = dateFilters;
        draft.filters = {
          ...draft.filters,
          ...filters,
        };
        if (filtersForDisplay) {
          draft.filtersForDisplay = filtersForDisplay;
        }
        break;
      }
      case RESET_FILTERS: {
        const {
          dateFilters: { range },
        } = draft.filters;

        draft.filters.appliedFilters = {
          ...initialState.filters.appliedFilters,
          startDate: moment(range[0]).format('YYYY-MM-DD 00:00:00'),
          endDate: moment(range[1])
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
        };

        draft.filtersForDisplay = initialState.filtersForDisplay;
        break;
      }
      case HANDLE_GET_REPORT_BY_ID_RESPONSE: {
        const { _id } = action.data;

        // eslint-disable-next-line no-underscore-dangle
        const index = draft.data.findIndex(obj => obj._id === _id);
        draft.data[index] = action.data;

        draft.isLoading = false;
        break;
      }
      case HANDLE_DOWNLOAD_REPORT_RESPONSE: {
        const fileName = getParam(action.data, 'filename');
        downloadFromUrl(action.data, fileName, true);
        draft.isLoading = false;
        break;
      }
      case HANDLE_DELETE_REPORT_RESPONSE: {
        const { _id } = action.data;
        // eslint-disable-next-line no-underscore-dangle
        const updatedData = draft.data.filter(obj => obj._id !== _id);
        draft.data = updatedData;
        draft.isLoading = false;
        break;
      }
      case HANDLE_GENERATE_REPORT_RESPONSE: {
        const { reportId } = action.data;
        const reportIndex = draft.data.findIndex(
          obj => obj.reportId === reportId,
        );
        if (reportIndex > -1) {
          draft.downloadModalData = {
            // eslint-disable-next-line no-underscore-dangle
            reportId: draft.data[reportIndex]._id,
            reportName: draft.data[reportIndex].name,
            type: draft.data[reportIndex].type,
          };
          draft.showDownloadModal = true;
        } else {
          draft.data.unshift({ ...action.data });
        }
        draft.isLoading = false;
        break;
      }
      case HANDLE_NEW_REPORT_STATUS: {
        const { reportId } = action.data;
        const reportIndex = draft.data.findIndex(
          obj => obj.reportId === reportId,
        );
        if (reportIndex > -1) {
          if (draft.data[reportIndex].status === 'REQUESTED')
            draft.data[reportIndex].status = 'PROCESSING';
        }
        break;
      }
      case RESET_MODAL: {
        draft.downloadModalData = {};
        draft.showDownloadModal = false;
        break;
      }
      case RESET_PAGE:
        draft.filters.pageNo = DEFAULT_CURRENT_PAGE;
        break;
      case RESET_DATA: {
        const obj = getInitialState();
        Object.keys(obj).forEach(k => (draft[k] = obj[k])); // eslint-disable-line
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default downloadReportReducer;
